import { render } from "./ChartV3.vue?vue&type=template&id=246b3f24&scoped=true"
import script from "./ChartV3.vue?vue&type=script&lang=js"
export * from "./ChartV3.vue?vue&type=script&lang=js"

import "./ChartV3.vue?vue&type=style&index=0&id=246b3f24&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-246b3f24"]])

export default __exports__